import { FC, memo } from 'react';

import { getFloatNumberRoundValue } from '@utils_iqfu/getFloatNumberRoundValue';

import { SalesStatsData } from '@type-def_iqfu/public/MarketData';

import { PublicPropertyType } from '@constants_iqfu';

import styles from '../trend_card_common.module.scss';

type Props = {
  displayData: SalesStatsData;
  areaName: string;
  propertyType: keyof typeof PublicPropertyType;
};

const AverageLandArea: FC<Props> = memo(({ displayData, areaName, propertyType }) => {
  const currentValue = displayData.average_land_area.current.value;
  const previousValue = displayData.average_land_area.previous.value;

  if (!currentValue || !previousValue) return <></>;

  return (
    <>
      {displayData.average_land_area.current.year ? (
        <div className={styles.container}>
          <div className={styles.trend_title}>
            {displayData.average_land_area.current.year}年に売れた{PublicPropertyType[propertyType]}の土地面積 （
            {areaName}）
          </div>

          <div className={styles.value_container}>
            <div className={styles.trend_value}>
              <p>{displayData.average_land_area.previous.year}年</p>
              <span className={styles.value}>{getFloatNumberRoundValue(previousValue, 1)}</span>
              <span className={styles.unit_label}>m2</span>
            </div>
            <div className={styles.compare_arrow}></div>
            <div className={styles.trend_value}>
              <p>{displayData.average_land_area.current.year}年</p>
              <span className={styles.value}>{getFloatNumberRoundValue(currentValue, 1)}</span>
              <span className={styles.unit_label}>m2</span>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
});

AverageLandArea.displayName = 'AverageLandArea';

export default AverageLandArea;
